import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/button/buttonlabelview
 */
import View from '../view.js';
/**
 * A default implementation of the button view's label. It comes with a dynamic text support
 * via {@link module:ui/button/buttonlabelview~ButtonLabelView#text} property.
 */
var ButtonLabelView = /*#__PURE__*/function (_View) {
  _inherits(ButtonLabelView, _View);
  var _super = _createSuper(ButtonLabelView);
  /**
   * @inheritDoc
   */
  function ButtonLabelView() {
    var _this;
    _classCallCheck(this, ButtonLabelView);
    _this = _super.call(this);
    _this.set({
      style: undefined,
      text: undefined,
      id: undefined
    });
    var bind = _this.bindTemplate;
    _this.setTemplate({
      tag: 'span',
      attributes: {
        class: ['ck', 'ck-button__label'],
        style: bind.to('style'),
        id: bind.to('id')
      },
      children: [{
        text: bind.to('text')
      }]
    });
    return _this;
  }
  return ButtonLabelView;
}(View);
export { ButtonLabelView as default };